const _configured = process.env.REACT_APP_API_BASE_URL?.trim() || '';
const _browserHost = typeof window !== 'undefined' ? window.location.hostname : '';
const _isLocal = ['localhost', '127.0.0.1', '0.0.0.0'].includes(_browserHost) ||
  String(process.env.NODE_ENV).toLowerCase() === 'development';
export const API_BASE = _configured || (_isLocal ? 'http://localhost:5000/api' : '');